import { Carousel } from './carousel'
import { CarouselProps } from './carousel-props'
import { Slide } from './slide'
import { SlideContainer } from './slide-container'
import { SlideViewport } from './slide-viewport'
import { CarouselControl, CarouselControlProps } from './carousel-control'

export type HeadlessCarouselProps<T> = CarouselProps<T>
export type HeadlessCarouselControlProps = CarouselControlProps

export const HeadlessCarousel = Object.assign(Carousel, { Slide, SlideContainer, SlideViewport, Control: CarouselControl })
